import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = [
  <path
    key="1"
    d="M9 13C8.44771 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11L20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13L9 13Z"
  />,
  <path key="2" d="M12 7L12 5L20 5C20.5523 5 21 5.44771 21 6C21 6.55228 20.5523 7 20 7L12 7Z" />,
  <path
    key="3"
    d="M15 19C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17L20 17C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19L15 19Z"
  />,
  <path
    key="4"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.74194 6.15368C7.1248 5.19296 7.65409 5.10204 9 4.99994C9.38923 4.97041 9.99956 4.99994 9.99956 4.99994L9.99999 6.99994C9.6017 6.975 9.26116 6.94938 8.79739 7.02406C8.59395 7.05682 8.48739 7.08106 8.28253 7.13959C7.87044 7.25733 7.36706 7.45994 6.88306 7.7962C5.96077 8.43694 5 9.6321 5 11.9999C5 14.3228 6.04509 15.5265 7.05084 16.1903C7.57395 16.5356 8.10379 16.7433 8.5061 16.864C8.70566 16.9239 8.86927 16.9609 8.97858 16.9825C9.03309 16.9932 9.07367 17 9.09798 17.0038L9.1218 17.0074C9.12068 17.0072 9.12004 17.0077 9.11989 17.0088C9.11826 17.0209 9.10514 17.1238 9 17.9999C8.89116 18.9069 8.88083 18.9853 8.87986 18.992C8.8798 18.9925 8.87953 18.9927 8.87908 18.9926L8.87855 18.9925L8.87578 18.9922L8.86885 18.9913L8.84952 18.9887C8.83423 18.9866 8.81419 18.9838 8.78971 18.9799C8.74078 18.9723 8.67394 18.9609 8.59174 18.9447C8.42761 18.9124 8.20059 18.8604 7.9314 18.7796C7.39621 18.6191 6.67605 18.3393 5.94916 17.8595C4.45491 16.8733 3 15.0771 3 11.9999C3 8.96777 4.28923 7.16294 5.74194 6.15368Z"
  />,
  <path key="5" d="M8 14L12 18L8 22L8 14Z" />,
];

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.11177 4.81399C4.7285 4.30005 5.58403 4.06994 6.50012 4.06994C6.81216 4.06994 7.06512 3.81698 7.06512 3.50494C7.06512 3.1929 6.81216 2.93994 6.50012 2.93994C5.41615 2.93994 4.27165 3.20983 3.38837 3.94589C2.48695 4.69706 1.93506 5.86907 1.93506 7.50494C1.93506 9.14081 2.48695 10.3128 3.38836 11.064C4.17588 11.7202 5.17103 12.0059 6.1458 12.0602L5.10054 13.1054C4.8799 13.3261 4.8799 13.6838 5.10054 13.9045C5.32119 14.1251 5.67893 14.1251 5.89957 13.9045L7.89957 11.9045C8.12022 11.6838 8.12022 11.3261 7.89957 11.1054L5.89957 9.10543C5.67893 8.88478 5.32119 8.88478 5.10054 9.10543C4.8799 9.32607 4.8799 9.68381 5.10054 9.90446L6.12258 10.9265C5.3511 10.8706 4.64288 10.6385 4.11177 10.1959C3.51317 9.69707 3.06506 8.86907 3.06506 7.50494C3.06506 6.14081 3.51317 5.31282 4.11177 4.81399ZM5.93506 7.50494C5.93506 7.81698 6.18802 8.06994 6.50006 8.06994H13.5001C13.8121 8.06994 14.0651 7.81698 14.0651 7.50494C14.0651 7.1929 13.8121 6.93994 13.5001 6.93994H6.50006C6.18802 6.93994 5.93506 7.1929 5.93506 7.50494ZM8.43506 3.50494C8.43506 3.81698 8.68802 4.06994 9.00006 4.06994L13.5001 4.06994C13.8121 4.06994 14.0651 3.81698 14.0651 3.50494C14.0651 3.1929 13.8121 2.93994 13.5001 2.93994H9.00006C8.68802 2.93994 8.43506 3.1929 8.43506 3.50494ZM9.93506 11.5049C9.93506 11.817 10.188 12.0699 10.5001 12.0699H13.5001C13.8121 12.0699 14.0651 11.817 14.0651 11.5049C14.0651 11.1929 13.8121 10.9399 13.5001 10.9399H10.5001C10.188 10.9399 9.93506 11.1929 9.93506 11.5049Z"
  />
);

export const DataGridCustomizationRowsIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="DataGridCustomizationRows" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
